var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMild(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.92 56.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fae489;}.cls-2,.cls-3{fill:none;stroke:#231f20;stroke-linecap:round;stroke-miterlimit:10;}.cls-2{stroke-width:2px;}.cls-3{stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 28.46,
    cy: 28.46,
    r: 28.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.79,21.7s4.58,6.21,8.76,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.1,21.7s4.58,6.21,8.76,0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 20.55,
    y1: 33.58,
    x2: 35.38,
    y2: 33.58
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMild);
export default __webpack_public_path__ + "static/media/mild.215687c327dfe945762df7e064c59f35.svg";
export { ForwardRef as ReactComponent };